import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AppHeader from 'components/AppHeader';
import AppSidebar from "components/AppSidebar";
import "views/appLayout/styles/appLayoutStyles.css"
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { DsLayout, EntityType,DocumentType, AppUserRole, IAppUserProfile } from "shared/constants";
import Loader from "components/Loader";
import Notification from "components/Notification";
import Breadcrumb from "components/Breadcrumb";
import AppFooter from "components/AppFooter";
import { createComponent } from "@lit-labs/react";
import { DSBanner } from "@ds/ds-snam";
import { Textlink } from "@ds/ds-snam/react";
import { useTranslation } from "react-i18next";
import { downloadDocument } from "net/contracts";
import { saveAs } from 'file-saver';
import { AppUser } from "ooAuth2/appUser";
import useAppUser from "hooks/useAppUser";

const AppLayout: React.FC<{}> = (): JSX.Element => {
    const {t} = useTranslation(['app']);
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const layoutMode = useSelector((state: RootState) => state.dsLayout.mode);

    useEffect(() => {
        const htmlElement = document.documentElement;
        if (layoutMode === DsLayout.DARK_MODE) {
            document.body.classList.add("dark-mode");
            htmlElement.classList.remove("snam_light_new-theme");
            htmlElement.classList.add("snam_dark_new-theme");
            htmlElement.style.backgroundColor = "#08143e";
            return;
        }

        document.body.classList.remove("dark-mode");
        htmlElement.classList.remove("snam_dark_new-theme");
        htmlElement.classList.add("snam_light_new-theme");
        htmlElement.style.backgroundColor = "#f9fafb";
    }, [layoutMode]);
    const [viewCookieBanner,setViewCookieBanner]=useState(true);

    const EditorialBanner = createComponent({
        react: React, 
        tagName: "ds-banner", 
        elementClass: DSBanner, 
        events: {
          onClickEvent: "onClickEvent",
          onCloseBanner: "onCloseBanner",
      }});

    const downloadCookieDocument = () => {
        downloadDocument("-1", EntityType.COOKIE, DocumentType.COOKIE)
            .then((response) => {
                let file = new File(
                    [response.data],
                    "Small_Scale_LNG_Cookie_Policy" + ".pdf"
                );
                saveAs(file);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    
    return (
        <>
            {viewCookieBanner && <EditorialBanner
                bannerType="cookie"
                bannerTitle={t('cookie.0', {ns:'app'})}
                isGradientColor={false}
                hasLeftButton={false}
                hasCloseIcon={true}
                zIndex={999}
                primaryRightButtonLabel={t('cookie.1', {ns:'app'})}
                primaryRightButtonAriaLabel="button aria text"
                secondaryRightButtonLabel={t('cookie.2', {ns:'app'})}
                secondaryRightButtonAriaLabel="button aria text"
                onClickEvent={(event:Event)=>{
                    setViewCookieBanner(false)
                }}
                >
                <div slot="content">
                    <div style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                    {t('cookie.3', {ns:'app'})}
                    <div onClick={downloadCookieDocument} style={{fontSize:'80%',color:layoutMode===DsLayout.DARK_MODE?'white':'blue',cursor:'pointer'}}>{t('cookie.4', {ns:'app'})}</div>
                    </div>
                </div>
                </EditorialBanner>}
                <AppHeader />
                {
                !(
                    appUserProfile?.dashboardMenuItem===false &&
                    appUserProfile?.contractsMenuItem===false &&
                    appUserProfile?.b2bMenuItem===false &&
                    appUserProfile?.prebillingMenuItem===false &&
                    appUserProfile?.settingsMenuItem===false
                )&&
                <>
                    <Breadcrumb />
                    <AppSidebar />
                    <Loader />
                    <Notification />
                    <div className="mainContentContainer" style={{backgroundColor:layoutMode===DsLayout.DARK_MODE?"var(--background-3)":"unset"}}>
                        <Outlet />
                    </div>
                </>
                }
                <AppFooter />
        </>
    )

}
export default AppLayout;